import { IconAngleRight } from '@iwoca/icons';
import { FormattedMessage } from 'react-intl';

import styles from './ChooseNewBankAccountVerification.module.css';

type TProps = {
    header: React.ReactNode;
    message: React.ReactNode;
    recommended: boolean;
    onClick: () => void;
};

export const BankAccountVerificationOption = ({
    header,
    message,
    recommended,
    onClick
}: TProps) => {
    return (
        <div className={styles.verificationOptionCardContainer}>
            <button className={styles.verificationOption} onClick={onClick}>
                {!!recommended && (
                    <p className={styles.recommendedTag}>
                        <FormattedMessage
                            id="_.funding_requirements.add_bank_details.choose_verification_method_recommended"
                            defaultMessage="Recommended"
                        />
                    </p>
                )}
                <div className={styles.optionHeaderRow}>
                    <h3 className={styles.optionHeaderRowTitle}>{header}</h3>
                    <IconAngleRight className={styles.iconAngleRight} />
                </div>
                <p className={styles.optionMessage}>{message}</p>
            </button>
        </div>
    );
};
